import React from 'react';
import cn from 'classnames';

import type { TIconName } from './types.generated';
import s from './styles.module.css';

interface ICssIconProps {
  size?: string;
  className?: string;
  color?: string;
  icon: TIconName;
}

const Icon: React.FC<ICssIconProps> = ({ size, className, color, icon }: ICssIconProps) => (
  <div
    role="img"
    aria-hidden="true"
    data-test-id={`icon__${icon}`}
    style={{ backgroundColor: color, height: size, width: size }}
    className={cn(className, s.icon, `wheely-icon-${icon}`)}
  />
);

export { Icon };
